module.exports = {"450222100":"大埔镇","450222101":"龙头镇","450222102":"太平镇","450222103":"沙埔镇","450222104":"东泉镇","450222105":"凤山镇","450222106":"六塘镇","450222107":"冲脉镇","450222108":"寨隆镇","450222109":"马山镇","450222200":"古砦仫佬族乡","450222202":"社冲乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450222.json
// module id = 2214
// module chunks = 0